import React, {createRef} from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import Context from '../../context/Context';
import ModalController from '../common/Modal/ModalController';
import Rdx from '../../redux/Rdx';

import "@esri/calcite-components/dist/components/calcite-accordion";
import "@esri/calcite-components/dist/components/calcite-accordion-item";
import "@esri/calcite-components/dist/components/calcite-action";
import "@esri/calcite-components/dist/components/calcite-block";
import "@esri/calcite-components/dist/components/calcite-button";
import "@esri/calcite-components/dist/components/calcite-checkbox";
import "@esri/calcite-components/dist/components/calcite-chip";
import "@esri/calcite-components/dist/components/calcite-input";
import "@esri/calcite-components/dist/components/calcite-label";
import "@esri/calcite-components/dist/components/calcite-list";
import "@esri/calcite-components/dist/components/calcite-list-item";
import "@esri/calcite-components/dist/components/calcite-panel";
import "@esri/calcite-components/dist/components/calcite-popover";

import {
  CalciteAccordion,
  CalciteAccordionItem,
  CalciteAction,
  CalciteBlock,
  CalciteButton,
  CalciteCheckbox,
  CalciteChip,
  CalciteInput,
  CalciteLabel,
  CalciteList,
  CalciteListItem,
  CalcitePanel,
  CalcitePopover,
} from "@esri/calcite-components-react";

interface State {
  primaryId?: string,  
  selectedIds: string[]
  foundIds: string[],
  foundPopoverOpen: boolean
}

let COUNTER = 0;
let COUNTERSEL = 0;
const MAX_FIND_RESULTS = -1;

const isPrimaryId = (primaryId,actionId) => {
  if (primaryId && actionId) {
    return primaryId.toLowerCase() === actionId.toLowerCase();
  }
  return false
}

const renderPrimaryChip = () => {
  const i18n = Context.instance.i18n;
  return (<CalciteChip value="primary">{i18n.policyActions.symbolizePalette}</CalciteChip>)
}

class AccordionItem extends React.Component<any, any> {

  nodeRef;
  wasSet = false;

  constructor (props: any) {
    super(props)
    this.nodeRef = createRef();;
  }

  render() {
    const extra: any = {};
    if (this.nodeRef) {
      // set the initial state to open (i.e. active), 
      // there are no CalciteAccordionItem events to track open/closed state
      const expanded = this.nodeRef && this.nodeRef.current && this.nodeRef.current.expanded;
      if (expanded === null) {
        if (this.props.numSelected > 0) {
          extra.expanded = true;
          this.wasSet = true;
        }
      } else {
        if (this.wasSet) extra.expanded = expanded;
      }
    }
    return (
      <CalciteAccordionItem {...this.props} ref={this.nodeRef} {...extra}>
        {this.props.children}
      </CalciteAccordionItem>      
    )
  }

}

class Selected extends React.Component<any, any> {

  id: string = null;

  constructor (props: any) {
    super(props)
    this.id = "id-pasel-"+COUNTERSEL++;
    this.state = {
      dropdownOpen: false
    }
  }

  componentDidUpdate(privProps,prevState) {
    const { dropdownOpen } = this.state;
    const { primaryId, selectedIds } = this.props;
    if (dropdownOpen && selectedIds.length < 1) {
      this.setState({dropdownOpen: false})
    }
  }

  render() {
    const i18n = Context.instance.i18n;
    const { dropdownOpen } = this.state;
    const { primaryId, selectedIds } = this.props;
    const options = [];
    selectedIds && selectedIds.forEach(id => {
      const opt = this.renderAction(id,id === primaryId);
      if (opt) options.push(opt);
    })
    const action = this.props.getAction(primaryId);
    const paletteInfo = this.props.getPaletteInfo(primaryId);
    let hasOptions = !!(action && options && (options.length > 0));
 
    return (
      <div style={{width: "100%", marginBottom: "0.75rem"}}>

        <CalciteButton id={this.id+"-btn"} slot="trigger"
          appearance="outline" kind="neutral"
          iconEnd={hasOptions ? "chevron-down" : undefined}
          disabled={action ? undefined : true}
          style={{height: "3rem"}}
          width="full"
          className='policy-select-btn'
        >
          {!action &&
            <span><i>{i18n.policyActions.select.noActionsSelected}</i></span>
          }
          {action &&
            <span style={{display: "flex", alignItems: "center"}}>
              <Swatch paletteInfo={paletteInfo} policyActionUtil={this.props.policyActionUtil} changeable={true} />
              <span className="g-policy-action-margin-lr g-text-wrap">{action.actionName}</span>
              {renderPrimaryChip()}
            </span>
          }
        </CalciteButton>

        {hasOptions &&
          <CalcitePopover 
              autoClose
              className="g-pa-popover"
              label={i18n.policyActions.select.selectPimary}
              placement="bottom"
              referenceElement={this.id+"-btn"}   
              open={dropdownOpen && hasOptions}
              onCalcitePopoverOpen={() => {
                this.setState({dropdownOpen: true})
                this.props.onSelectPopoverOpen();
              }}
              onCalcitePopoverClose={() => {
                this.setState({dropdownOpen: false})
              }}
            >
            <CalciteList>
              <CalciteListItem key="hdr">
                <div className="g-pa-dropdown-header">
                  <div>
                    <span>{i18n.policyActions.select.selectPimary}</span>
                    <CalciteButton 
                      appearance='transparent' style={{margin: '0 1rem 0 1rem'}}
                      onClick={() => {
                        this.setState({dropdownOpen: false})
                        this.props.onClearClick()
                      }}
                    >
                      {i18n.policyActions.clearAllSelection}
                    </CalciteButton>
                  </div>
                </div>
              </CalciteListItem>
              {options}
            </CalciteList>
          </CalcitePopover>
        }

      </div>
    )
  }

  renderAction(actionId,isPrimary) {
    const i18n = Context.instance.i18n;
    const action = this.props.getAction(actionId);
    const paletteInfo = this.props.getPaletteInfo(actionId);
    if (action && paletteInfo) {
      return (
        <CalciteListItem key={actionId}>
          <div style={{display: "flex", justifyContent: "space-between"}}>
            <CalciteButton appearance="transparent"
              onClick={() => {
                this.setState({dropdownOpen: false})
                this.props.onPrimaryIdChanged(actionId,false);
              }}
            >
              <span style={{display: "flex", alignItems: "center"}}>
                <Swatch paletteInfo={paletteInfo} policyActionUtil={this.props.policyActionUtil} />
                <span className="g-policy-action-margin-lr g-text-wrap">{action.actionName}</span>
              </span>
            </CalciteButton>
            <span style={{display: "flex", alignItems: "center"}}>
              {isPrimary && renderPrimaryChip()}
              <CalciteAction icon="trash" text={i18n.general.remove} title={i18n.general.remove} 
                onClick={() => this.props.onRemoveClick(actionId)}
              />
            </span>
          </div>
        </CalciteListItem>
      )
    }
  }

}

class Swatch extends React.Component<any, any> {

  nodeRef: React.RefObject<HTMLSpanElement> = createRef();
  surfaceWidth: number = 30;
  surfaceHeight: number = 30;
  wgt;

  constructor (props: any) {
    super(props)
  }

  componentDidMount() {
    this.initWidget();
  }

  componentDidUpdate(prevProps) {
    if (this.props.changeable) {
      const { paletteInfo, policyActionUtil } = this.props;
      const prevPaletteInfo = prevProps.paletteInfo;
      if (paletteInfo && prevPaletteInfo && (paletteInfo.typeId !== prevPaletteInfo.typeId)) {
        const node = this.nodeRef && this.nodeRef.current;
        if (node && this.wgt) {
          this.wgt.destroy();
          this.wgt = null;
          this.initWidget();
        }
      }
    }
  }

  initWidget() {
    try {
      if (this.wgt) return;
      const { paletteInfo, policyActionUtil } = this.props;
      const node = this.nodeRef && this.nodeRef.current;
      if (node) {
        const subNode = document.createElement("span");
        node.appendChild(subNode);
        let wgt = this.wgt = policyActionUtil.makeSwatch(subNode,paletteInfo,this.surfaceWidth,this.surfaceHeight);
        if (wgt) wgt.startup();
      }
    } catch(ex) {
      console.error(ex);
    }
  }

  render() {
    return <span><span ref={this.nodeRef}></span></span>
  }

}

export default class SelectPolicyActions extends React.Component<any, State> {

  id: string = null;

  constructor (props: any) {
    super(props)
    this.id = "id-pa-"+COUNTER++;
    const { policyActionUtil, primaryActionId, delimitedActionIds, paletteIndex} = this.props;
    const ids = policyActionUtil.splitIds(delimitedActionIds,false);
    const idInfo = policyActionUtil.normalizeIds(primaryActionId,ids,paletteIndex);
    let primaryId = idInfo.lcPrimaryId;
    const selectedIds = idInfo.lcSelectedIds;
    const action = this.getAction(primaryId);
    if (!action) primaryId = null;
    if (!primaryId && selectedIds.length > 0) primaryId = selectedIds[0];
    this.state = {
      primaryId: primaryId,
      selectedIds: selectedIds,      
      foundIds: [],
      foundPopoverOpen: false
    }
    this._onChange();
  }

  clearAll = () => {
    this.setState({primaryId: null, selectedIds: []},this._onChange);
  }

  countSelected = (policy) => {
    let n = 0;
    const { selectedIds } = this.state;
    policy.actions.forEach(action => {
      const lc = action.actionId.toLowerCase();
      const idx = selectedIds.indexOf(lc);
      if (idx !== -1) n++;
    })
    return n;
  }

  countTotalSelected = () => {
    const { policyActionUtil } = this.props;
    const policyActions = policyActionUtil.getPolicyActions();
    const themes = policyActionUtil.getEnabledThemes(policyActions);
    let numSelected = 0;
    if (themes && themes.length > 0) {
      themes.forEach(theme => {
        theme.policies.forEach(policy => {
          numSelected += this.countSelected(policy);
        })
      })
    }
    return numSelected;
  }

  getAction = (actionId) => {
    const { policyActionUtil } = this.props;
    const policyActions = policyActionUtil.getPolicyActions();
    return policyActions.actionsByActionId[actionId && actionId.toLowerCase()];
  }

  getPaletteInfo = (actionId) => {
    const { paletteIndex } = this.props;
    return paletteIndex && actionId && paletteIndex[actionId && actionId.toLowerCase()];
  }

  _onChange = () => {
    const { policyActionUtil, policyActionIdsField, paletteIndex } = this.props;
    let { primaryId, selectedIds } = this.state;
        if (typeof this.props.onChange === "function") {
      const idInfo = policyActionUtil.normalizeIds(primaryId,selectedIds,paletteIndex);
      const delimitedActionIds = idInfo.delimitedActionIds;
      const primaryActionId = idInfo.primaryActionId;
      const paletteInfo = this.getPaletteInfo(primaryActionId)
      if (paletteInfo && paletteInfo.typeTemplate && paletteInfo.typeTemplate.prototype) {
        var attributes = paletteInfo.typeTemplate.prototype.attributes;
        if (attributes && policyActionIdsField && delimitedActionIds) {
          attributes[policyActionIdsField.name] = delimitedActionIds;
        }
              }
      this.props.onChange(primaryActionId,delimitedActionIds,paletteInfo);
    }    
  }

  onCheckChange = (action,checked) => {
    const { policyActionUtil, paletteIndex } = this.props;
    let { primaryId } = this.state;
    let changed = false;
    let selectedIds = this.state.selectedIds.slice();
    const lc = action.actionId.toLowerCase();
    const idx = selectedIds.indexOf(lc);
    const wasPrimary = isPrimaryId(primaryId,action.actionId);
    if (checked) {
      if (idx === -1) {
        selectedIds.push(lc);
        changed = true;
      }
    } else {
      if (idx !== -1) {
        selectedIds.splice(idx,1);
        changed = true;
      }
    }
    if (changed) {
      if (wasPrimary && !checked) primaryId = null;
      const idInfo = policyActionUtil.normalizeIds(primaryId,selectedIds,paletteIndex);
      primaryId = idInfo.lcPrimaryId;
      selectedIds = idInfo.lcSelectedIds;
      const newState: any = {selectedIds: selectedIds};
      if (wasPrimary && !checked) newState.primaryId = null;;
      if (!primaryId && selectedIds.length > 0) {
        primaryId = selectedIds[0];
        newState.primaryId = primaryId;
              }
      this.setState(newState, this._onChange);
    }
  }

  render() {
    const i18n = Context.instance.i18n;
    const { primaryId, selectedIds } = this.state;
    const { policyActionUtil } = this.props;
    const themes = this.renderThemes() || null;
    const numSelected = this.countTotalSelected();
    const sel = i18n.policyActions.select.totalSelectedPattern.replace("{numSelected}",numSelected);
    const desc = themes ? sel : null;
    return (
      <>
        <p style={{margin: "10px 15px 15px"}}>{desc}</p>
        <div className="policy-content" style={{padding: "0.75rem 0.75rem"}}>
          <Selected 
            primaryId={primaryId} 
            selectedIds={selectedIds} 
            policyActionUtil={policyActionUtil}
            getAction={this.getAction}
            getPaletteInfo={this.getPaletteInfo}
            onPrimaryIdChanged={(id,ignore) => {
              this.setState({primaryId: id}, () => {
                if (!ignore) this._onChange();
              });
            }}
            onClearClick={() => {
              this.clearAll()
            }}
            onRemoveClick={id => {
              this.onCheckChange(this.getAction(id),false);
            }}
            onSelectPopoverOpen={() => {
              this.setState({foundPopoverOpen: false})
            }}
          />
          {this.renderFind()}
          {themes}
        </div>
      </>
    )
  }

  renderAction(action) {
    const { primaryId, selectedIds } = this.state;
    const checked = (selectedIds.indexOf(action.actionId.toLowerCase()) !== -1);
    const paletteInfo = this.getPaletteInfo(action.actionId);
    const isPrimary = isPrimaryId(primaryId,action.actionId);
    return (
      <div key={action.actionId} style={{display: "flex"}}>
        <CalciteLabel layout="inline" style={{marginInlineEnd: "0.5rem", cursor: isPrimary ? "auto" : "pointer"}}>
          <CalciteCheckbox
            checked={checked ? checked : null}
            onCalciteCheckboxChange={(e) => {
              // @ts-ignore
              this.onCheckChange(action,!!e.target.checked)
            }}
          />
          <Swatch paletteInfo={paletteInfo} policyActionUtil={this.props.policyActionUtil} />
          <span>{action.actionName}</span>
        </CalciteLabel>
        {isPrimary && renderPrimaryChip()}
      </div>
    )
  }

  renderFind() {
    const i18n = Context.instance.i18n;
    const { policyActionUtil } = this.props;
    const { foundIds, foundPopoverOpen } = this.state;
    const options = [];
    foundIds && foundIds.forEach(id => {
      const opt = this.renderFoundItem(id);
      if (opt) options.push(opt);
    })
    const hasOptions = options && (options.length > 0);

    return (
      <div style={{marginBottom: "0.5rem"}}>
        <CalciteInput id={this.id+"-find"} type="text" scale="l" icon="search" clearable
          placeholder={i18n.policyActions.select.findPlaceholder}
          onCalciteInputInput={(evt => {
            // @ts-ignore
            const ids = policyActionUtil.findActionIds(evt.target.value);
            if (MAX_FIND_RESULTS > 0) ids.length = MAX_FIND_RESULTS;
            this.setState({foundIds: ids})
            this.setState({foundPopoverOpen: ids.length > 0})
          })}
        />
        {hasOptions &&
          <CalcitePopover autoClose
            className="g-pa-popover"
            
            label={i18n.policyActions.select.findPlaceholder}
            placement="bottom"
            referenceElement={this.id+"-find"}   
            open={foundPopoverOpen}
            onCalcitePopoverOpen={() => {
              this.setState({foundPopoverOpen: true})
            }}
            onCalcitePopoverClose={() => {
              this.setState({foundPopoverOpen: false})
            }}
          >
            {hasOptions &&
              <CalciteList style={{margin: "0.25rem 0.5rem"}}>
                {options}
              </CalciteList>
            }
          </CalcitePopover>
        }
      </div>
    );
  }

  renderFoundItem(actionId) {
    const i18n = Context.instance.i18n;
    const { primaryId, selectedIds } = this.state;
    const action = this.getAction(actionId);
    const paletteInfo = this.getPaletteInfo(actionId);
    const isPrimary = isPrimaryId(primaryId,action.actionId);
    const checked = (selectedIds.indexOf(actionId.toLowerCase()) !== -1);
    if (action && paletteInfo) {
      return (
        <CalciteListItem key={actionId}>
          <div style={{display: "flex"}}>
            <CalciteLabel layout="inline" style={{marginInlineEnd: "0.5rem", cursor: isPrimary ? "auto" : "pointer"}}>
              <CalciteCheckbox
                checked={checked ? checked : null}
                onCalciteCheckboxChange={(e) => {
                  // @ts-ignore
                  this.onCheckChange(action,!!e.target.checked)
                }}
              />
              <Swatch paletteInfo={paletteInfo} policyActionUtil={this.props.policyActionUtil} />
              <span>{action.actionName}</span>
            </CalciteLabel>
            {isPrimary && renderPrimaryChip()}
          </div>
        </CalciteListItem>
      )
    }
  }

  renderPolicy(policy) {
    const i18n = Context.instance.i18n;
    const numSelected = this.countSelected(policy);

    const actionNodes = policy.actions.map(action => {
      return this.renderAction(action);
    })

    let title = policy.policyName;
    if (numSelected > 0) {
      const pattern = i18n.policyActions.select.selectedPattern;
      title = pattern.replace("{name}",policy.policyName).replace("{numSelected}",numSelected);
    }

    return (
      <AccordionItem key={policy.policyId} heading={title} numSelected={numSelected}>
        <div style={{padding: '0.75rem 0.5rem 0.25rem 0.5rem'}}>
          {actionNodes}
        </div>
      </AccordionItem>
    )
  }

  renderTheme(theme) {
    const i18n = Context.instance.i18n;
    let numSelected = 0;

    const policyNodes = theme.policies.map(policy => {
      numSelected += this.countSelected(policy);
      return this.renderPolicy(policy)
    })

    let title = theme.themeName;
    if (numSelected > 0) {
      const pattern = i18n.policyActions.select.selectedPattern;
      title = pattern.replace("{name}",theme.themeName).replace("{numSelected}",numSelected);
    }

    return (
      <AccordionItem key={theme.themeId} heading={title} numSelected={numSelected}>
        {policyNodes}
      </AccordionItem>
    )
  }

  renderThemes() {
    const i18n = Context.instance.i18n;
    const { policyActionUtil } = this.props;
    const policyActions = policyActionUtil.getPolicyActions();
    const themes = policyActionUtil.getEnabledThemes(policyActions);
    let numSelected = 0;

    if (themes && themes.length > 0) {
      const themeNodes = themes.map(theme => {
        theme.policies.forEach(policy => {
          numSelected += this.countSelected(policy);
        })
        return this.renderTheme(theme)
      })

      return (
        <>
          <div className='g-section-medium' style={{margin: '0 0 0.5rem 0'}}>
            <span></span>
          </div>
          <CalciteAccordion icon-type="chevron" scale="m">
            {themeNodes}
          </CalciteAccordion>
          <div className="policy-btn-container">
            <CalciteButton 
              appearance='outline' scale="m" 
              onClick={this.clearAll}
            >
              {i18n.policyActions.clearAllSelection}
            </CalciteButton>
          </div>
        </>
      )

    } else {
      // @todo show a message, no themes
    }
    return null;
  }

  static showModal(params: any): void {
    const i18n = Context.instance.i18n;
    const { policyActionUtil } = params;
    let delimitedActionIds = undefined;
    let primaryActionId = undefined;      
    
    const options = {
      title: i18n.policyActions.select.caption,
      small: true,
      content: (
        <SelectPolicyActions {...params}
          onChange={(primaryId,delimitedIds,paletteInfo) => {
            delimitedActionIds = delimitedIds;
            primaryActionId = primaryId    
          }}
        />
      ),
      onOK: () => {
        //let delimited = delimitedActionIds;
        if (delimitedActionIds !== undefined) {
          // if (params.requiredActionId) {
          //   const policyActions = policyActionUtil.getPolicyActions();
          //   const ids = policyActionUtil.splitIds(delimited);
          //   ids.unshift(params.requiredActionId);
          //   delimited = policyActionUtil.asDelimited(policyActions,ids);
          // }
          if (typeof params.onSelect === "function") {
            params.onSelect(primaryActionId,delimitedActionIds);
          }
        }
      }
    }
    const controller = new ModalController();
    controller.show(options);
  }

}

